// extracted by mini-css-extract-plugin
export default {"item":"Item_item__uCBGy","label":"Item_label__JdH6B","value":"Item_value__tF1AD"};